'use client';

import { resolveProvider } from './providers';
import type { EmbedShortcodeProps } from './types';
import { YouTubeEmbed } from './renderers/YouTubeEmbed';
import { EvervizEmbed } from './renderers/EvervizEmbed';
import { TwitterEmbed } from './renderers/TwitterEmbed';
import { InstagramEmbed } from './renderers/InstagramEmbed';
import { TikTokEmbed } from './renderers/TikTokEmbed';
import { GenericEmbed } from './renderers/GenericEmbed';

/**
 * Client dispatcher for `[hen-ui-embed]`. Routes to the per-provider renderer
 * based on the `provider` attribute; unknown providers fall back to a
 * sandboxed generic iframe.
 */
export function EmbedClient({
  provider,
  src,
  url,
  id,
  title,
  'aspect-ratio': ratio,
}: EmbedShortcodeProps) {
  switch (resolveProvider(provider)) {
    case 'youtube':
      return (
        <YouTubeEmbed src={src} url={url} id={id} title={title} ratio={ratio} />
      );
    case 'everviz':
      return (
        <EvervizEmbed src={src} url={url} id={id} title={title} ratio={ratio} />
      );
    case 'twitter':
      return <TwitterEmbed src={src} url={url} id={id} />;
    case 'instagram':
      return <InstagramEmbed url={url} src={src} title={title} />;
    case 'tiktok':
      return <TikTokEmbed url={url} src={src} id={id} title={title} />;
    default:
      return <GenericEmbed src={src} url={url} title={title} ratio={ratio} />;
  }
}
